import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Box } from '../../utils/material-ui-core';

interface TabPanelProps {
  children?: React.ReactNode;
  id: any;
  currentSelectedId: any;
  h: string;
  w: string;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, currentSelectedId, id, h, w, ...other } = props;

  const pageStyles = LocalPageStyles();

  const getBoxStyle = () => {
    let boxStyle = {};

    if (w !== "" && h !== "") {
      boxStyle = { width: w, height: h };
    } else if (w !== "") {
      boxStyle = { width: w };
    } else if (h !== "") {
      boxStyle = { height: h };
    }

    return boxStyle;
  };
  return (
    <Box style={getBoxStyle()} role="tabpanel" hidden={currentSelectedId !== id} id={`scrollable-auto-tabpanel-${id}`} aria-labelledby={`scrollable-auto-tab-${id}`} {...other}>
      {currentSelectedId === id && <Box className={pageStyles.contentContainer}>{children}</Box>}
    </Box>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      width: "100%",
      height: "100%",
      paddingTop: 30,
    },
  })
);

export default TabPanel;
